import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'orca-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent {

  @Input("isActive") isActive: boolean = false
  @Input("disabled") disabled: boolean = false
  /** Texto quando desabilitado ("Fixo", "bloq."). Vazio: mostra Ativo/Inativo esmaecido. */
  @Input("disabledLabel") disabledLabel: string = "Fixo"
  @Input("ariaLabel") ariaLabel?: string
  @Output("toggle") outputToggle = new EventEmitter<boolean>()

  get label(): string {
    if (this.disabled && this.disabledLabel) {
      return this.disabledLabel;
    }
    return this.isActive ? 'Ativo' : 'Inativo';
  }

  toggleSwitch() {
    if (this.disabled) {
      return;
    }
    this.outputToggle.emit(!this.isActive);
  }

}
